import React, { Component } from 'react';

import BaseModal from '../BaseModal';
import NoteForm from 'components/NoteForm/NoteForm';
import { getCarrierPrefix } from 'helpers/subs';
import Spinner from 'components/Spinner';

class AddNoteModal extends Component {
  state = {
    loading: false,
  };

  handleAddNote = (values) => {
    const { createNote, fetchNotes, onClose, userId, subId, carrier } =
      this.props;
    let subKey;
    if (subId && carrier) {
      subKey = getCarrierPrefix(carrier) + 'subscription';
    }

    const params = {
      text: values.text,
      user_profile: userId,
    };
    if (subKey) {
      params[subKey] = subId;
    }

    this.setState({ loading: true });
    return createNote(params)
      .then(() => fetchNotes())
      .then(() => onClose())
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { loading } = this.state;
    return (
      <BaseModal
        title="Add Note"
        confirmBtnText=""
        cancelBtnText=""
        {...this.props}
      >
        <NoteForm onSubmit={this.handleAddNote} />
        <Spinner showLoader={loading} />
      </BaseModal>
    );
  }
}

export default AddNoteModal;
